export const SET_LOADING = 'SET_LOADING'
export const UPDATE_STEVEDORES = 'UPDATE_STEVEDORES'
export const DELETE_STEVEDORE = 'DELETE_STEVEDORE'
